import type { SvgProps } from "./types";

export const Rings = ({
  width = "100px",
  height = width,
  color = "#000000",
}: SvgProps) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={width}
      height={height}
      viewBox="0 0 934 683"
      enable-background="new 0 0 934 683"
    >
      <title>Rings</title>
      <path
        fill={color}
        opacity="1.000000"
        stroke="none"
        d="
M935.000000,474.000000 
	C935.000000,485.687561 935.000000,497.375122 934.627869,509.733490 
	C933.507935,515.919006 932.814758,521.441833 932.002197,526.946960 
	C929.464600,544.137878 924.818848,560.812805 917.100708,576.326111 
	C904.212036,602.232117 883.773926,621.737793 861.044250,638.915833 
	C844.862000,651.145447 827.711731,662.022156 808.772949,669.471375 
	C797.164429,674.037476 785.083496,677.476685 773.064392,680.893127 
	C767.220764,682.554260 761.032349,683.002625 755.000000,684.000000 
	C743.645752,684.000000 732.291565,684.000000 720.257568,683.622803 
	C703.425293,681.475952 687.117554,680.579956 671.153992,677.745789 
	C642.274536,672.618408 613.805725,665.464966 586.019043,655.975037 
	C569.223938,650.239136 552.470276,644.255798 536.119812,637.380432 
	C520.606323,630.856995 504.698730,624.489075 490.657257,615.429138 
	C469.405884,601.717041 449.570282,585.800293 429.231598,570.687744 
	C414.129608,559.466309 399.244751,547.951599 384.079376,536.817932 
	C382.469116,535.635742 379.362213,535.344971 377.395081,535.992981 
	C368.439240,538.943176 359.589264,542.240234 350.803589,545.674438 
	C341.547424,549.292603 332.649200,554.042786 323.158264,556.792236 
	C309.883789,560.637756 296.316681,563.790649 282.671143,565.957764 
	C265.688660,568.654785 248.539001,570.980408 231.386185,571.721069 
	C216.077301,572.382080 200.621902,571.172974 185.314117,569.837891 
	C173.790298,568.832947 162.267120,566.903503 150.974182,564.361450 
	C128.074081,559.206604 106.427155,550.696106 86.463463,538.144165 
	C68.915726,527.111145 53.589901,513.623840 41.046776,497.096954 
	C30.519241,483.225861 21.651440,468.300812 16.098303,451.779785 
	C11.443622,437.931732 7.828582,423.724182 4.053998,409.595459 
	C2.606769,404.178314 1.993357,398.538391 0.999999,393.000000 
	C1.000000,379.312439 1.000000,365.624878 1.372120,351.266510 
	C4.450105,336.511169 6.684544,322.315735 9.965563,308.366455 
	C15.776785,283.660034 26.902754,261.032196 39.524269,239.251236 
	C51.929138,217.844116 66.211540,197.610504 83.135902,179.470444 
	C96.329865,165.328720 109.601479,151.188461 123.755089,138.033630 
	C137.087601,125.641953 151.403229,114.268738 165.671112,102.931702 
	C188.755600,84.589142 213.820419,69.129089 239.724548,55.218105 
	C271.843506,37.969635 305.141418,23.138638 340.554779,13.953885 
	C358.033112,9.420727 375.944702,6.547762 393.680145,3.023661 
	C398.080383,2.149314 402.557983,1.664091 407.000000,1.000001 
	C423.020905,1.000000 439.041779,1.000000 455.733765,1.372262 
	C472.783447,2.929088 488.774048,6.097437 504.447479,10.982955 
	C530.655029,19.152027 554.002136,32.342876 573.731262,51.433640 
	C581.283813,58.741821 588.265808,66.800323 594.538757,75.237358 
	C608.597900,94.146698 618.723633,115.216599 624.821411,137.932831 
	C628.449219,151.447433 630.280884,165.440125 633.040527,179.193695 
	C634.191467,184.929871 635.369995,190.474609 641.999084,193.085464 
	C658.833374,199.715591 675.383484,207.074463 692.267151,213.570312 
	C717.126953,223.134933 741.759338,233.153183 764.475220,247.225769 
	C790.410645,263.292908 815.401001,280.789124 837.775940,301.562805 
	C850.874573,313.723969 863.026123,326.997650 874.796326,340.475891 
	C893.522583,361.919586 908.419861,385.890533 919.077087,412.383423 
	C924.931213,426.936279 929.945190,441.725220 932.058899,457.373444 
	C932.811646,462.946350 934.006775,468.459564 935.000000,474.000000 
M861.828613,618.011841 
	C873.436707,614.596252 881.629150,605.641235 880.485413,597.532288 
	C873.751526,604.137756 867.046448,610.714966 859.908081,617.667969 
	C859.789917,618.039062 859.671692,618.410156 859.553528,618.781250 
	C860.060181,618.547852 860.566895,618.314514 861.828613,618.011841 
M812.869568,650.011108 
	C827.258606,647.775635 837.572510,639.293701 846.594666,628.421875 
	C841.502808,627.036926 838.290222,628.440125 835.833740,632.930603 
	C834.629944,635.131226 831.847839,636.593994 829.564819,638.054138 
	C823.551880,641.899841 817.421204,645.561401 810.864258,649.670715 
	C810.391296,649.932617 809.918396,650.194519 809.445435,650.456421 
	C809.547180,650.667297 809.648865,650.878235 809.750610,651.089111 
	C810.524902,650.753113 811.299194,650.417175 812.869568,650.011108 
M524.049927,207.985260 
	C511.319214,209.319702 498.560822,210.436310 485.865234,212.047440 
	C472.089142,213.795700 458.276855,215.521179 444.662537,218.187057 
	C435.997498,219.883774 427.951233,223.844910 421.402954,228.987503 
	C434.070312,228.987503 446.989807,228.987961 459.909302,228.984940 
	C460.241699,228.984848 460.587402,228.999268 460.904633,228.918991 
	C475.963867,225.107162 488.824341,229.554474 501.001404,240.000000 
	C498.730652,240.000000 497.166351,240.000000 495.602081,240.000000 
	C482.774719,240.000000 469.944855,240.158661 457.120758,239.954132 
	C444.981171,239.760529 433.176788,241.741852 422.035645,246.231110 
	C414.919739,249.098419 408.482635,253.650253 401.741211,257.446838 
	C401.994476,258.207458 402.247772,258.968048 402.501038,259.728668 
	C404.863220,259.728668 407.377716,260.263428 409.562561,259.640930 
	C422.657562,255.910110 435.950104,253.966644 449.541534,255.089920 
	C453.768066,255.439240 457.906738,256.851959 463.300629,258.047058 
	C456.535339,264.952240 449.575226,267.688538 441.716187,267.934662 
	C432.729187,268.216156 423.725433,267.907043 414.731079,268.022736 
	C401.856110,268.188324 393.005707,275.829376 390.323395,289.746857 
	C396.855225,288.069946 403.016876,286.678741 409.063873,284.898163 
	C424.343689,280.398956 439.604492,276.024048 455.820740,276.963928 
	C463.116699,277.386810 469.081146,279.856018 473.239075,286.530426 
	C472.128967,287.117279 471.340454,287.681580 470.461578,287.976288 
	C459.640656,291.604858 448.509796,289.543182 437.497040,289.784851 
	C432.851379,289.886749 427.997131,289.698730 423.622284,290.968109 
	C415.037689,293.458923 406.635284,296.663544 398.343201,300.030243 
	C395.431061,301.212616 393.063385,303.736023 389.368652,306.434845 
	C401.863007,311.391357 412.189392,307.542572 422.705902,305.596863 
	C424.145355,310.112274 421.059662,312.359253 417.598145,313.597260 
	C413.960052,314.898315 409.919342,315.028992 406.173370,316.090302 
	C404.012054,316.702637 400.230865,318.830688 400.333649,319.108307 
	C401.716736,322.843475 403.307220,326.613159 405.561127,329.881256 
	C407.562042,332.782501 410.442749,331.090027 413.006470,330.021362 
	C416.057709,328.749481 419.174805,327.635437 422.263336,326.452972 
	C422.639008,326.903046 423.014679,327.353088 423.390381,327.803162 
	C422.690735,329.271362 422.194611,330.887573 421.254150,332.180603 
	C418.179443,336.407990 414.764984,340.400360 411.893555,344.755005 
	C411.174927,345.844879 411.428345,348.457428 412.292450,349.444000 
	C413.051300,350.310394 415.694275,350.556854 416.801697,349.896851 
	C420.290924,347.817505 423.856079,345.577942 426.660187,342.690002 
	C435.416656,333.671844 443.917358,324.400238 452.364105,315.087982 
	C460.115814,306.541962 468.139984,298.182831 475.219116,289.098480 
	C494.748840,264.036896 511.859009,237.394974 526.091919,208.331970 
	C526.210144,207.960892 526.328308,207.589813 526.446472,207.218735 
	C525.939819,207.452087 525.433167,207.685440 524.049927,207.985260 
M888.190308,587.236816 
	C894.132812,578.459778 900.880737,570.113770 905.854492,560.818420 
	C917.107239,539.788391 921.604553,516.700073 921.682678,493.155121 
	C921.731934,478.331207 919.412659,463.374390 916.903687,448.691132 
	C910.189209,409.397095 890.914612,376.321869 863.929932,347.685516 
	C850.982056,333.945099 837.138123,320.944305 822.824280,308.626160 
	C809.321899,297.006378 794.935974,286.353302 780.466125,275.931030 
	C754.935303,257.541840 727.986633,241.449448 698.995300,229.067581 
	C681.611389,221.643097 664.003601,214.732513 646.387756,207.869751 
	C642.725525,206.443054 638.584534,206.245422 634.000732,205.352066 
	C634.000732,210.421539 634.158264,214.391006 633.952759,218.341614 
	C633.776367,221.734070 634.905151,223.046265 638.477051,223.118637 
	C641.843994,223.186890 645.311707,223.878662 648.527527,224.930771 
	C677.949219,234.556595 706.080078,247.209564 733.163757,262.115234 
	C749.614014,271.168701 766.012634,280.413086 781.766052,290.604767 
	C794.376282,298.762970 805.949463,308.518341 818.036133,317.493195 
	C834.204041,329.498596 848.235168,343.784271 861.287354,358.969421 
	C874.805115,374.696442 885.226196,392.539703 893.669495,411.435150 
	C899.417664,424.299255 903.745239,437.655731 904.020935,452.008057 
	C904.330078,468.098816 899.828918,482.981995 893.234009,497.437469 
	C887.130188,510.816559 878.640930,522.381226 865.312683,528.839783 
	C855.744141,533.476440 845.375916,537.055725 834.972595,539.243958 
	C817.405029,542.939026 799.611694,546.127930 781.752441,547.687500 
	C767.786255,548.907227 753.507690,548.090088 739.492371,546.812256 
	C722.564087,545.268860 705.530762,543.355652 688.962769,539.699768 
	C654.794373,532.160461 622.065857,520.034302 590.445007,505.063019 
	C564.553223,492.804138 539.305420,479.361877 515.013489,464.092285 
	C491.669678,449.418610 469.095612,433.660065 448.818573,415.035126 
	C428.279633,396.169556 409.092072,375.992401 395.426666,351.148499 
	C386.488190,334.898346 379.877014,317.949097 378.147644,299.544495 
	C375.980011,276.474945 380.168243,254.353271 391.078217,233.722916 
	C395.614441,225.145081 400.472839,216.992279 409.842896,212.393494 
	C414.848969,209.936523 419.111755,205.965149 424.297058,202.257446 
	C422.832214,202.129379 422.168365,201.914154 421.579529,202.042740 
	C404.298676,205.815842 388.663879,213.457474 373.843903,222.825836 
	C370.503052,224.937744 367.884888,228.192902 364.156403,231.640915 
	C370.006592,230.848389 374.308228,230.265656 378.609894,229.682907 
	C378.879822,230.092987 379.149719,230.503082 379.419647,230.913162 
	C378.343445,232.370346 377.572174,234.417206 376.128510,235.163696 
	C372.982788,236.790298 369.560089,238.520828 366.131439,238.813477 
	C360.737305,239.273911 358.231873,242.853195 356.274719,246.722809 
	C353.534302,252.141052 353.395142,252.386124 349.439362,247.711868 
	C335.037842,265.110748 323.451416,284.280090 316.315308,305.695648 
	C310.134827,324.243469 306.046326,343.389130 309.039490,363.196930 
	C310.743988,374.476715 312.069153,385.925659 315.109222,396.869507 
	C322.354431,422.951416 335.455109,446.240540 350.681213,468.526459 
	C362.959686,486.498108 376.636871,503.263794 391.624603,518.934937 
	C400.187622,527.888306 409.383789,536.323669 418.924377,544.232910 
	C431.394257,554.570496 444.144379,564.644104 457.390625,573.953857 
	C478.002563,588.440369 499.731842,601.223450 522.862488,611.278320 
	C546.630981,621.610474 570.450256,631.965027 594.805481,640.764954 
	C614.824951,647.998291 635.494873,653.653198 656.193604,658.709595 
	C670.753601,662.266418 685.779785,664.324768 700.721741,665.775879 
	C712.152588,666.886047 723.810852,666.552124 735.307312,665.856750 
	C748.935913,665.032410 762.499451,663.131348 776.091187,661.696960 
	C776.018616,661.061829 775.945984,660.426758 775.873413,659.791687 
	C772.321289,660.194275 768.773010,660.901917 765.216309,660.947388 
	C748.850342,661.156860 732.490601,661.344360 716.305725,658.053101 
	C699.206726,654.575989 682.042908,651.418457 664.923096,648.041870 
	C658.688965,646.812317 652.552734,644.630188 646.277832,644.173279 
	C637.290161,643.518860 638.018860,645.097168 638.014160,635.154724 
	C638.013672,634.194580 638.186584,633.234314 638.271912,632.347717 
	C651.959900,635.419373 665.444275,638.513000 678.960205,641.462097 
	C698.557129,645.738037 718.420471,648.577698 738.437256,648.778992 
	C752.393860,648.919373 766.428040,647.460999 780.317627,645.798584 
	C788.363708,644.835571 796.192017,642.053772 804.118347,640.090454 
	C804.039307,639.635498 803.960266,639.180481 803.881226,638.725464 
	C794.996338,638.725464 786.111389,638.725464 777.226501,638.725464 
	C776.942383,638.294128 776.658203,637.862732 776.374084,637.431396 
	C780.128967,634.515137 783.883850,631.598877 788.432312,628.066284 
	C776.311584,623.945435 766.111633,620.477600 755.020691,616.706848 
	C767.617676,615.732971 779.097107,615.645142 790.293640,613.821228 
	C817.486450,609.391357 842.849976,600.593506 863.110046,580.574280 
	C866.932861,576.796814 871.244751,572.686279 877.725342,573.977539 
	C882.663879,574.961487 885.686829,572.142334 887.362244,568.070984 
	C889.884094,561.942627 891.926819,555.617126 894.245667,549.174011 
	C899.169617,549.052612 901.132385,551.253357 899.804932,556.304138 
	C899.312500,558.178162 898.416687,559.951111 897.652954,561.748169 
	C894.083801,570.146118 890.496582,578.536377 886.389160,587.166138 
	C886.343018,587.611023 886.296936,588.055969 886.250854,588.500854 
	C886.728516,588.228333 887.206116,587.955750 888.190308,587.236816 
M158.518433,271.956421 
	C156.142868,274.696136 153.584106,277.299164 151.421539,280.197784 
	C137.518906,298.832184 124.885864,318.202881 115.625298,339.678528 
	C106.980194,359.726868 101.593391,380.459747 101.052391,402.311432 
	C100.759666,414.134766 101.212692,425.976929 100.897255,437.799072 
	C100.768204,442.635803 103.200157,445.144104 106.964912,446.880402 
	C109.156151,447.890961 111.588089,448.452911 113.964607,448.976837 
	C132.166229,452.989532 150.686478,454.153473 169.234909,454.970947 
	C174.057999,455.183533 178.981964,454.466187 183.712173,455.168640 
	C196.970215,457.137543 210.223663,456.486969 222.971512,453.271667 
	C239.834610,449.018372 256.460968,443.622925 272.847260,437.762604 
	C281.983063,434.495331 290.508667,429.447357 299.148560,424.896820 
	C304.011963,422.335358 306.125854,417.974030 304.937469,412.439148 
	C303.535309,405.908783 301.764954,399.453522 300.493744,392.899841 
	C298.196228,381.054840 294.868439,369.212402 294.389587,357.271881 
	C293.976746,346.977631 296.243530,336.394928 298.527588,326.209259 
	C304.164703,301.070862 313.587830,277.336121 326.471008,254.955460 
	C338.828796,233.487564 355.620758,216.817871 377.800812,205.610535 
	C398.728882,195.035767 420.688080,187.397552 443.463745,181.970184 
	C462.106720,177.527603 480.714813,172.933090 500.071442,172.993774 
	C511.068726,173.028244 522.070251,172.828308 533.061707,173.084641 
	C537.428589,173.186508 539.953125,170.809799 540.642212,167.408585 
	C542.197205,159.733307 543.506592,151.915207 543.826233,144.110565 
	C544.109863,137.187088 541.034912,131.269760 534.053833,128.593216 
	C526.005249,125.507355 517.933777,122.382561 509.665436,119.989159 
	C493.588654,115.335442 477.179443,112.228165 460.375153,112.065582 
	C453.611328,112.000137 446.792389,112.269180 440.083191,113.083450 
	C427.749725,114.580322 415.314575,115.856842 403.218384,118.554848 
	C382.052582,123.275810 361.245483,129.488052 341.573486,138.816315 
	C322.690826,147.770294 303.550629,156.334213 285.364838,166.564972 
	C263.722595,178.740250 243.293045,192.916733 223.819229,208.474960 
	C203.243530,224.913528 183.860657,242.536728 166.342682,262.195343 
	C163.731430,265.125671 161.390701,268.297089 158.518433,271.956421 
M324.901062,465.375885 
	C321.725922,462.023773 318.062744,462.702057 314.433380,464.281647 
	C301.114990,470.078033 287.774902,475.829865 274.550446,481.835114 
	C261.550018,487.738739 248.097198,491.372986 233.725418,490.991608 
	C222.788681,490.701385 211.854080,490.331360 200.918335,490.003052 
	C189.649704,489.664764 178.381714,489.301056 167.111755,489.014130 
	C161.734253,488.877197 156.281876,483.128723 156.265579,476.591492 
	C160.385269,477.132660 164.460144,477.404449 168.413467,478.246735 
	C174.936188,479.636475 181.391754,482.767914 187.855316,482.714294 
	C201.657028,482.599884 215.695129,482.186768 229.174362,479.541595 
	C244.766006,476.481903 259.902435,471.026672 275.157043,466.352203 
	C285.261444,463.255890 295.156921,459.470367 305.285614,456.464020 
	C309.713501,455.149780 315.027039,456.350677 317.874603,451.254639 
	C314.593353,441.692017 310.199615,439.177155 300.416931,441.955963 
	C295.117340,443.461334 289.922974,445.462067 284.862579,447.657623 
	C275.756683,451.608368 267.157379,457.421631 257.684143,459.686096 
	C237.874008,464.421417 217.717239,467.937134 197.543564,470.851044 
	C180.163879,473.361450 162.574142,474.480591 145.048874,475.852173 
	C142.399826,476.059509 139.466751,474.573700 136.890656,473.382965 
	C131.150635,470.729797 125.749886,467.244568 119.860199,465.031830 
	C103.519501,458.892670 86.912384,453.493530 71.803398,444.430267 
	C59.802151,437.231201 49.604248,428.269775 42.086998,416.387482 
	C32.824795,401.747009 29.281740,385.290833 28.165525,368.435760 
	C26.854118,348.633240 28.725563,328.976227 33.650433,309.624481 
	C39.375324,287.129120 48.600861,266.169434 59.954147,246.010361 
	C76.097740,217.345535 96.479797,191.940643 119.230957,168.362579 
	C126.483704,160.846222 134.118225,153.671402 141.898743,146.698105 
	C151.211365,138.351639 160.353149,129.670059 170.486267,122.414810 
	C189.327133,108.924843 208.346542,95.551117 228.208740,83.661011 
	C245.408447,73.364754 263.431274,64.128799 281.901581,56.350792 
	C304.096405,47.004353 327.233673,40.076042 350.765930,34.478661 
	C372.486328,29.312254 394.403442,25.390793 416.613739,24.273254 
	C431.242981,23.537167 446.138245,24.343542 460.670502,26.284843 
	C483.530273,29.338583 503.752899,39.624722 521.392456,54.145695 
	C543.971619,72.733032 556.652344,97.080452 558.904114,126.375038 
	C560.060181,141.414093 558.950317,156.500610 555.751465,171.220993 
	C551.444763,191.039185 544.769226,210.228729 535.206055,228.088394 
	C526.123962,245.049622 516.281860,261.698425 505.499084,277.621246 
	C498.347809,288.181580 489.319702,297.572266 480.473755,306.859772 
	C467.374847,320.612549 453.604492,333.723511 440.313568,347.297241 
	C436.540894,351.150177 433.287506,355.549133 430.086334,359.910797 
	C427.941315,362.833374 428.847961,365.857635 431.028778,368.502808 
	C433.387604,371.363831 435.992401,369.933319 438.047852,368.373077 
	C444.702332,363.321869 451.560883,358.436035 457.615112,352.718170 
	C471.810089,339.311707 485.033813,325.009277 497.111786,309.580811 
	C511.874420,290.722870 525.056152,270.858368 536.447632,249.872238 
	C548.462097,227.738342 558.784180,204.800217 565.311340,180.335068 
	C569.037170,166.369873 571.451721,152.250198 572.139099,137.752289 
	C572.606140,127.901962 568.964600,119.100540 566.911865,109.877983 
	C565.931519,105.473198 567.699768,103.386688 572.142883,102.923172 
	C576.633545,102.454697 578.284485,105.560417 578.857849,108.586128 
	C580.587891,117.715652 581.352295,127.028717 583.097717,136.154602 
	C585.321899,147.783722 584.001709,159.266846 581.595093,170.500961 
	C577.170410,191.155319 569.231323,210.660461 560.064148,229.650513 
	C546.887939,256.945648 531.666199,283.069702 513.803589,307.545166 
	C502.510956,323.018463 491.014496,338.454468 478.280548,352.721039 
	C471.096985,360.769196 461.313416,366.538574 452.526672,373.100952 
	C445.234680,378.546936 443.404205,386.170227 448.258301,393.497559 
	C449.883636,395.951019 451.663605,398.491852 453.925720,400.301849 
	C465.688416,409.713654 477.483337,419.098938 489.568512,428.088196 
	C495.865906,432.772369 496.448334,435.260315 504.782501,426.580841 
	C514.501770,416.458954 524.229492,406.257141 532.974365,395.307922 
	C546.444763,378.441956 559.284058,361.058197 572.023132,343.625244 
	C589.559631,319.627136 601.412048,292.806641 609.980896,264.479767 
	C617.321350,240.213913 621.586792,215.480576 619.948181,190.023865 
	C619.273315,179.539017 618.609558,168.990829 616.877747,158.649490 
	C613.115051,136.180832 604.827271,115.302933 592.567566,96.088791 
	C582.506531,80.320625 570.404419,66.432831 555.531006,54.841263 
	C541.483459,43.893318 526.428772,34.948055 509.896088,28.445044 
	C482.318695,17.597622 453.629639,13.250785 424.100555,14.027088 
	C418.660095,14.170115 413.205414,14.450952 407.798309,15.042749 
	C396.393829,16.290941 384.863953,17.043129 373.660767,19.340876 
	C352.268402,23.728403 331.411713,30.102556 310.942780,37.865772 
	C276.256622,51.021137 243.644470,68.158066 212.472321,88.101387 
	C190.243698,102.322830 168.684189,117.538132 149.186264,135.398026 
	C134.825912,148.551971 120.259445,161.590546 107.023415,175.831711 
	C93.518387,190.362320 81.105545,205.974564 68.977448,221.701599 
	C53.620667,241.615387 41.835270,263.763275 32.187881,286.910919 
	C23.182341,308.518524 16.253143,330.899902 15.115500,354.472443 
	C14.359536,370.136505 13.889452,385.974579 15.351101,401.541382 
	C16.887197,417.901031 21.918213,433.694122 27.850861,449.170959 
	C37.611439,474.633881 52.974308,495.975128 73.872505,513.202026 
	C92.179008,528.292542 113.011894,539.152344 135.388840,546.962524 
	C164.439713,557.102112 194.537338,561.232788 225.160965,561.929443 
	C231.752548,562.079407 238.393082,561.610352 244.960159,560.932983 
	C254.073517,559.992981 263.249756,559.123718 272.202789,557.274048 
	C294.514099,552.664368 315.005035,542.641235 336.302155,535.000305 
	C344.709381,531.984009 353.367371,529.669556 361.893890,526.980713 
	C363.608917,526.439880 366.559998,525.799011 366.655762,524.947327 
	C366.881989,522.935120 366.274353,520.358215 365.045532,518.735291 
	C359.849060,511.872101 354.082550,505.438171 348.934235,498.541382 
	C340.916718,487.801086 333.232086,476.812256 324.901062,465.375885 
M815.619934,530.003235 
	C821.650208,529.319946 827.697754,528.758240 833.704285,527.907227 
	C837.219421,527.409058 837.474731,525.060303 836.580994,522.036682 
	C832.461426,508.098969 827.402466,494.614014 820.476196,481.734436 
	C811.255249,464.587952 799.960083,448.966492 786.936768,434.677002 
	C777.894836,424.755981 768.247070,415.223907 757.899170,406.696014 
	C743.778381,395.058868 729.171448,383.891815 713.991943,373.684753 
	C685.103577,354.259521 653.271973,340.321899 621.543640,326.320679 
	C613.987854,322.986420 607.363464,322.938782 600.830139,330.295166 
	C588.859924,343.773407 580.229126,359.369080 570.347046,374.184570 
	C561.631042,387.251892 554.122681,401.222504 542.408875,412.081604 
	C533.552612,420.291748 524.602539,428.403351 515.877075,436.749908 
	C513.923584,438.618622 512.384644,441.131958 511.286774,443.626617 
	C510.101685,446.319489 511.339905,448.056213 514.353882,449.039978 
	C519.732666,450.795654 525.203979,452.548157 530.203918,455.137421 
	C555.604431,468.291077 580.737244,481.965210 606.212952,494.969086 
	C631.024292,507.633789 657.400513,515.928406 684.488098,522.374573 
	C709.471191,528.319946 734.773804,531.540161 760.305115,532.824646 
	C773.355286,533.481201 786.502441,532.471497 799.593384,531.919617 
	C804.647949,531.706543 809.668152,530.675964 815.619934,530.003235 
M71.986275,343.431641 
	C68.689911,356.747681 65.393539,370.063721 62.068577,383.495270 
	C61.763023,383.031677 61.203960,382.546814 61.107838,381.983002 
	C59.707714,373.770264 58.396267,365.542328 56.994572,357.329865 
	C56.704048,355.627686 56.133282,353.973297 55.691685,352.296936 
	C53.770172,353.065643 51.539967,353.459442 50.017662,354.712952 
	C48.615051,355.867920 47.642010,357.837311 47.048641,359.635712 
	C42.546719,373.280212 46.003014,386.192474 51.384914,398.679810 
	C57.364918,412.554962 67.268440,423.621582 78.293655,433.683899 
	C80.834389,436.002747 84.018272,437.616882 88.139885,440.383423 
	C87.880455,435.839630 87.943115,432.905975 87.503838,430.049530 
	C86.462578,423.278656 84.349609,416.565704 84.176414,409.790833 
	C83.833229,396.366791 88.467529,383.731476 92.538666,371.183563 
	C96.506226,358.954895 101.004967,346.840729 106.180504,335.076660 
	C112.428291,320.875305 118.697693,306.536224 126.628510,293.254395 
	C141.204086,268.844574 159.446960,247.210815 181.006943,228.547943 
	C193.938202,217.354324 206.775360,206.015259 220.213455,195.452271 
	C241.835953,178.455917 265.124115,163.898132 289.381439,150.960205 
	C321.600677,133.775711 354.900421,119.270767 390.319305,109.778488 
	C409.975006,104.510750 429.829437,100.328720 450.062012,99.233162 
	C468.350067,98.242897 486.878021,97.731613 504.913666,102.131744 
	C513.369507,104.194725 521.647766,107.225296 529.712036,110.534836 
	C532.906128,111.845650 535.300720,115.104408 538.200378,117.597519 
	C543.086914,110.749321 540.424072,104.852699 537.743774,99.680893 
	C526.875732,78.710098 511.076447,62.251984 490.185333,51.111317 
	C470.582397,40.657619 449.132568,36.939552 427.242126,36.174225 
	C417.073578,35.818718 406.787109,36.890572 396.649536,38.109291 
	C385.308777,39.472660 373.987061,41.316788 362.814697,43.692955 
	C338.526001,48.858738 314.837067,56.328224 292.135590,66.254562 
	C272.268066,74.941734 252.674484,84.527313 233.890167,95.333145 
	C219.074768,103.855820 205.281708,114.333130 191.746323,124.857658 
	C175.544037,137.455856 159.540710,150.422745 144.466568,164.330475 
	C125.621277,181.717545 107.889954,200.282394 92.505615,220.947113 
	C77.183716,241.527985 64.359245,263.538330 56.157074,287.846466 
	C51.173595,302.615601 47.991570,317.995880 44.086430,333.123871 
	C42.704525,338.477173 41.285065,343.854645 40.506516,349.310059 
	C40.261097,351.029724 42.045345,353.039062 42.900650,354.915802 
	C43.931538,353.544464 45.257301,352.299194 45.912354,350.767212 
	C46.600189,349.158508 46.643764,347.274719 46.971695,345.511658 
	C52.439861,316.113159 61.069874,287.810760 76.576660,261.998596 
	C81.328537,254.088776 86.722343,246.564560 91.822189,238.863754 
	C92.888725,240.100708 93.089249,240.832550 92.859428,241.385544 
	C86.916290,255.685776 80.936150,269.970673 74.944839,284.250824 
	C72.017952,291.227020 68.436729,298.030945 69.215263,306.781494 
	C82.007896,284.642120 93.320076,262.434692 109.966629,243.133163 
	C113.791840,248.060883 113.810516,251.997620 111.194679,256.338745 
	C106.643684,263.891357 102.134041,271.484161 97.992287,279.265137 
	C87.220856,299.501099 78.783768,320.718353 71.986275,343.431641 
M707.998657,261.499054 
	C693.419128,254.890686 678.969177,247.972229 664.207153,241.800400 
	C656.439026,238.552658 648.179871,236.413895 640.038086,234.149673 
	C634.958374,232.736984 631.967529,235.951096 633.113464,241.116486 
	C633.388550,242.356491 634.041199,243.512756 634.505554,244.671158 
	C656.904297,246.892532 680.290527,257.892303 683.533691,267.790192 
	C665.436401,264.185944 647.391357,260.592133 629.346252,256.998322 
	C629.078613,257.601746 628.811035,258.205200 628.543396,258.808624 
	C631.661072,260.553009 634.614136,262.750000 637.927917,263.955078 
	C647.095520,267.289032 656.467041,270.060822 665.645935,273.365845 
	C669.304993,274.683350 671.121765,277.392456 669.150513,281.543640 
	C667.022705,286.024353 664.000000,283.888763 661.265991,282.635132 
	C651.163269,278.002838 641.172241,273.124695 631.035645,268.569489 
	C623.643555,265.247620 622.231262,266.535095 620.894836,274.448669 
	C618.845581,286.583649 618.022034,299.305389 608.054016,308.700378 
	C609.257324,309.452484 610.159180,310.178772 611.182251,310.631073 
	C625.062439,316.766907 639.131042,322.505890 652.815857,329.048157 
	C679.686829,341.894348 706.138062,355.531647 731.070801,371.970245 
	C759.119690,390.463318 785.022888,411.295441 806.216431,437.644592 
	C825.951050,462.179871 839.108948,489.645874 844.390503,520.770020 
	C850.694519,519.060913 852.832703,516.953918 851.894531,512.984253 
	C850.023132,505.065765 848.543640,496.988098 845.862915,489.340485 
	C839.002441,469.768250 830.576233,450.898560 815.464294,436.054901 
	C802.333923,423.157684 788.812012,410.659210 775.470276,397.977020 
	C772.361572,395.022095 770.182800,391.630646 771.038269,387.098083 
	C771.294495,385.740601 771.993347,384.466644 772.489380,383.154388 
	C773.764709,383.713898 775.321777,383.976685 776.271851,384.878784 
	C785.905823,394.026093 795.638184,403.083801 804.947510,412.555237 
	C814.111145,421.878357 823.015137,431.476227 831.672729,441.272034 
	C841.559753,452.458862 848.117920,465.501556 852.042847,479.932861 
	C854.475830,488.878662 857.235779,497.741547 860.126770,506.550507 
	C860.583496,507.942139 862.368225,509.210449 863.835022,509.802765 
	C864.413818,510.036530 866.358582,508.459473 866.736389,507.377167 
	C870.701538,496.017395 872.647705,484.105591 870.737488,472.352295 
	C867.389771,451.754089 858.844971,433.153137 846.095520,416.466644 
	C839.886169,408.339844 834.523743,399.603485 832.621033,389.127472 
	C846.557556,401.725128 860.318909,414.425964 866.767456,433.093140 
	C868.664185,432.249573 870.370728,431.490601 872.678223,430.464355 
	C862.024963,412.240173 851.663513,394.515259 841.447937,377.039856 
	C841.354980,377.024780 842.138062,376.919922 842.581299,377.259125 
	C847.396057,380.943726 852.258423,384.577606 856.902893,388.469788 
	C860.919983,391.836182 865.344849,395.031494 868.356934,399.194214 
	C871.460571,403.483429 872.958801,408.909027 875.390381,413.720734 
	C876.559570,416.034332 878.260254,418.079346 879.720215,420.246002 
	C880.230530,420.033508 880.740784,419.821014 881.251099,419.608551 
	C880.851257,417.131042 881.057983,414.333160 879.947632,412.230896 
	C874.836304,402.553101 869.900940,392.708832 863.865112,383.612549 
	C857.182800,373.541962 849.635132,364.005188 841.972778,354.637970 
	C835.704529,346.975067 829.496643,338.933228 821.872437,332.781525 
	C808.285889,321.818970 794.202087,311.253571 779.324768,302.160675 
	C756.199829,288.026917 732.236389,275.264984 707.998657,261.499054 
M529.078674,190.369934 
	C528.841614,189.952271 528.706238,189.394485 528.352417,189.137680 
	C521.604431,184.239761 514.362549,182.954361 506.089905,184.869278 
	C495.238495,187.381119 484.194305,189.060089 473.054688,191.130432 
	C473.365265,194.628693 475.893188,195.036713 478.971497,195.026199 
	C495.418732,194.970032 511.866241,195.008392 528.313599,194.981079 
	C529.507385,194.979095 530.700684,194.715027 532.538208,194.496063 
	C531.197021,192.936249 530.359314,191.961990 529.078674,190.369934 
M843.336792,612.925354 
	C835.034607,618.583557 826.249207,621.441406 815.552368,616.565979 
	C816.275696,618.249023 816.398926,619.167542 816.759888,619.273071 
	C819.075073,619.950317 821.559448,620.172424 823.753540,621.099365 
	C825.342590,621.770752 826.569519,623.299194 827.957825,624.445435 
	C826.605957,625.627747 825.403015,627.104004 823.850525,627.890320 
	C822.791687,628.426697 821.122986,627.662354 819.946411,628.087219 
	C818.473694,628.619019 817.225891,629.773621 815.880981,630.659424 
	C816.179199,631.289001 816.477417,631.918518 816.775635,632.548096 
	C823.602783,630.656616 831.475037,630.268188 836.963806,626.451843 
	C842.475891,622.619324 845.613220,615.371399 849.791260,609.620239 
	C849.403564,609.276489 849.015869,608.932739 848.628174,608.589050 
	C847.072571,609.895874 845.516968,611.202759 843.336792,612.925354 
M887.992737,430.099457 
	C887.532471,429.035919 887.072205,427.972382 886.098083,425.721436 
	C883.221863,431.956879 881.965759,436.953918 884.057556,442.326019 
	C884.424927,443.269501 885.312439,444.010376 885.959778,444.844849 
	C886.636841,443.881195 887.832275,442.951508 887.898010,441.947845 
	C888.136414,438.305908 887.996155,434.639130 887.992737,430.099457 
M60.720634,333.493958 
	C56.571125,337.484070 55.394062,342.278870 56.457722,348.561310 
	C61.377796,344.215515 62.557896,339.633820 60.720634,333.493958 
M850.716980,608.640625 
	C850.469910,608.339111 850.222900,608.037537 849.975769,607.736023 
	C850.009827,608.157166 850.043884,608.578308 850.716980,608.640625 
z"
      />

      <path
        fill={color}
        opacity="1.000000"
        stroke="none"
        d="
M829.328918,566.314880 
	C816.177063,568.354736 803.435425,570.772827 790.581604,571.839050 
	C777.543274,572.920593 764.336853,573.578857 751.308533,572.760132 
	C736.144531,571.807068 721.065247,569.244446 706.000366,567.031616 
	C679.115051,563.082581 653.098450,555.584229 627.702942,546.160950 
	C608.764404,539.133606 590.105408,531.284424 571.609131,523.148438 
	C537.393005,508.097809 505.268921,489.241394 474.469879,468.118561 
	C456.328522,455.676697 438.422638,442.894714 422.815430,427.258820 
	C415.079559,419.508728 407.726776,411.376617 400.008545,403.608246 
	C397.526917,401.110535 394.430725,399.223389 391.210175,396.744812 
	C390.649078,401.946777 391.658264,405.603912 395.461182,408.301941 
	C396.608948,409.116241 397.211731,410.655975 398.231415,411.700073 
	C413.916687,427.760742 429.669067,443.756134 445.307343,459.862274 
	C449.063660,463.730988 452.462524,467.946686 456.945526,473.049805 
	C446.947174,469.235779 438.912842,464.397858 432.617859,457.803497 
	C421.145111,445.785126 410.920227,432.582825 399.598022,420.410950 
	C391.897095,412.132111 383.521698,404.403809 374.889832,397.087738 
	C364.707855,388.457794 358.467316,378.265320 357.924683,364.653442 
	C357.518188,354.455933 356.424377,344.285797 356.729645,333.895844 
	C358.485229,339.893494 360.081848,345.943390 362.032471,351.876892 
	C365.232605,361.611420 368.542236,371.314545 372.069336,380.934235 
	C373.123535,383.809448 375.130249,386.323883 376.571564,389.071289 
	C379.032837,393.762878 382.872314,394.837067 387.891479,393.584137 
	C383.598663,383.453064 379.062408,373.534027 375.162201,363.370911 
	C368.142456,345.079071 361.983093,326.534149 359.942902,306.857147 
	C358.316589,291.171692 358.140686,275.607361 361.876251,260.158173 
	C362.564575,257.311462 362.327484,254.175217 363.351593,251.490814 
	C364.878204,247.489410 367.785217,244.776749 373.344025,245.101364 
	C368.913879,258.948792 368.532166,272.718811 369.028503,286.535400 
	C369.624420,303.125122 371.989288,319.509491 376.849670,335.373596 
	C380.517822,347.346375 384.314667,359.422729 389.655121,370.694519 
	C393.868652,379.587769 399.480988,388.338226 406.316467,395.355560 
	C418.617554,407.983948 431.728516,419.990570 445.560547,430.915710 
	C460.796204,442.949463 476.886353,453.999298 493.229065,464.505859 
	C509.557373,475.003143 526.571045,484.451965 543.452209,494.065399 
	C554.400818,500.300385 565.341919,506.702820 576.832458,511.798859 
	C598.286316,521.313599 619.976257,530.349976 641.870667,538.801270 
	C662.265808,546.673828 683.513977,551.913147 705.012634,555.798218 
	C714.841736,557.574524 724.898987,558.307373 734.889160,558.915405 
	C746.467529,559.619995 758.110718,560.291260 769.680298,559.831787 
	C782.296570,559.330811 794.903564,557.842102 807.437012,556.194092 
	C823.308716,554.107178 839.090088,551.339417 854.945068,549.111938 
	C856.870544,548.841431 859.010742,550.099854 861.113220,551.415955 
	C852.222473,560.205322 840.933472,563.103943 829.328918,566.314880 
z"
      />
      <path
        fill={color}
        opacity="1.000000"
        stroke="none"
        d="
M321.705444,312.639404 
	C325.025177,301.034821 329.923370,290.900513 338.770630,283.232269 
	C339.321625,283.434784 339.872620,283.637299 340.423615,283.839813 
	C339.953674,291.557800 339.143372,299.273987 339.102234,306.994232 
	C339.053772,316.093781 339.596924,325.200256 340.015228,334.297668 
	C340.935791,354.319244 343.561676,374.139282 349.349945,393.330566 
	C351.876312,401.706818 356.434937,409.453674 359.745514,417.618195 
	C361.020721,420.763031 361.393005,424.273987 361.477448,427.813751 
	C339.432068,409.259399 337.082703,382.706696 332.975159,356.358582 
	C326.262024,360.476715 327.241638,366.405090 328.302490,371.116760 
	C333.797577,395.521454 343.552979,418.235443 356.897278,439.423248 
	C368.287506,457.508331 381.225647,474.353363 395.583008,490.206696 
	C412.937531,509.369629 431.379822,527.298279 452.200745,542.658936 
	C463.772736,551.196228 475.509308,559.522827 487.406677,567.598206 
	C490.561981,569.739868 494.657227,570.447754 498.196991,572.082336 
	C505.077576,575.259766 505.411896,578.482727 498.772888,584.266541 
	C491.513367,579.995911 483.773407,575.839233 476.447571,571.049133 
	C461.959839,561.576111 446.932892,552.697388 433.556763,541.817444 
	C419.264069,530.191956 406.399750,516.760010 393.342133,503.686890 
	C386.377625,496.714172 379.831879,489.197144 373.964417,481.282806 
	C363.948090,467.772125 354.066864,454.098450 345.143463,439.857483 
	C335.675354,424.747192 328.023285,408.519104 323.310791,391.277191 
	C320.270264,380.152618 318.806854,368.569977 317.044739,357.129730 
	C314.727264,342.083862 317.590515,327.465149 321.705444,312.639404 
z"
      />
      <path
        fill={color}
        opacity="1.000000"
        stroke="none"
        d="
M484.943237,490.157959 
	C483.540680,495.183258 476.173767,498.105621 472.851929,495.075348 
	C471.773621,494.091644 471.058655,491.205872 471.713165,490.094879 
	C474.139587,485.976257 481.405945,485.988586 484.943237,490.157959 
z"
      />
      <path
        fill={color}
        opacity="1.000000"
        stroke="none"
        d="
M364.042633,438.988892 
	C362.778809,437.675751 361.924561,436.367981 361.070343,435.060211 
	C362.387054,434.377686 363.719299,433.152863 365.015411,433.190002 
	C365.992371,433.217957 366.923065,434.862122 367.874329,435.786865 
	C366.733643,436.856018 365.592957,437.925140 364.042633,438.988892 
z"
      />
      <path
        fill={color}
        opacity="1.000000"
        stroke="none"
        d="
M461.055878,475.787079 
	C461.054596,471.072571 463.989136,472.118774 467.514740,472.109894 
	C466.781342,474.300995 466.607086,476.363708 465.488464,477.480774 
	C464.967865,478.000610 462.614624,476.685333 461.055878,475.787079 
z"
      />
      <path
        fill={color}
        opacity="1.000000"
        stroke="none"
        d="
M593.321777,279.247894 
	C586.833313,292.963257 580.127808,306.085754 568.908386,316.625488 
	C571.289551,306.966034 573.670654,297.306580 576.051819,287.647156 
	C575.703796,287.407471 575.355774,287.167816 575.007751,286.928162 
	C569.438110,293.661194 563.868408,300.394226 558.116394,307.347717 
	C554.497803,304.210663 554.038208,300.496552 555.665466,296.910828 
	C561.203674,284.706482 567.079956,272.655823 572.796021,260.531769 
	C575.584412,254.617477 578.335205,248.684967 581.038757,242.731522 
	C582.136353,240.314590 583.643555,237.752991 586.443298,239.225800 
	C588.146851,240.121902 589.058289,242.837540 589.914612,244.905975 
	C590.383606,246.038635 589.998474,247.524887 590.793091,249.065598 
	C593.142212,241.826752 595.911438,234.691269 597.725159,227.320694 
	C599.632019,219.571442 600.770630,211.619507 601.975159,203.715027 
	C603.159485,195.943710 604.398926,188.145477 604.889526,180.313675 
	C605.387390,172.366608 604.999390,164.364044 604.999390,156.360428 
	C609.790039,155.152481 611.903748,158.132523 612.947815,161.365540 
	C614.684875,166.744720 616.684326,172.333893 616.835022,177.881836 
	C617.685608,209.209991 609.242859,238.704178 598.092468,267.582916 
	C596.624268,271.385437 595.068359,275.154114 593.321777,279.247894 
z"
      />
      <path
        fill={color}
        opacity="1.000000"
        stroke="none"
        d="
M120.339882,512.721680 
	C127.356133,515.959839 133.847504,519.616821 140.795319,521.860107 
	C148.643127,524.393860 156.938065,525.508850 164.971695,527.509277 
	C175.714890,530.184387 186.437668,532.962952 197.088989,535.980286 
	C209.703629,539.553772 221.681412,537.942505 233.311264,532.315247 
	C233.587006,532.181824 233.935257,532.198303 234.250565,532.150024 
	C238.817993,538.565063 237.719147,542.137329 230.208832,545.020569 
	C220.156219,548.879578 209.861572,549.717651 199.050323,549.181519 
	C167.163315,547.600220 138.607590,535.915955 110.942482,521.379395 
	C96.114571,513.588135 82.632202,503.724884 70.130913,492.567200 
	C68.929276,491.494720 68.166489,489.930603 67.783073,487.984589 
	C85.194214,496.161835 102.605362,504.339050 120.339882,512.721680 
z"
      />
      <path
        fill={color}
        opacity="1.000000"
        stroke="none"
        d="
M543.759338,291.753357 
	C537.713684,298.737579 531.917542,305.455414 526.121399,312.173248 
	C525.727295,311.916382 525.333130,311.659485 524.939026,311.402618 
	C525.268250,310.459137 525.423889,309.403046 525.952148,308.588715 
	C538.376404,289.437103 551.295471,270.586121 563.087585,251.054352 
	C568.245850,242.510605 570.977295,232.523804 575.061096,223.303177 
	C579.278198,213.781296 584.847778,205.277573 595.521301,199.273926 
	C580.104004,232.010483 564.865234,263.301331 543.759338,291.753357 
z"
      />
      <path
        fill={color}
        opacity="1.000000"
        stroke="none"
        d="
M544.084106,346.070648 
	C537.146545,357.451599 530.215942,368.836792 523.264832,380.209381 
	C522.075623,382.154999 520.491211,383.916962 519.616211,385.986511 
	C515.954651,394.647003 508.125305,399.219818 501.388123,404.836029 
	C498.327393,407.387512 494.906799,409.507355 490.923950,411.104065 
	C508.219208,389.323730 525.514465,367.543427 543.254272,345.729065 
	C543.827271,345.820251 543.955688,345.945435 544.084106,346.070648 
z"
      />
      <path
        fill={color}
        opacity="1.000000"
        stroke="none"
        d="
M543.507568,345.505920 
	C543.793823,345.044006 544.271362,344.771240 544.748901,344.498474 
	C544.702942,344.943451 544.657043,345.388397 544.347595,345.952026 
	C543.955688,345.945435 543.827271,345.820251 543.507568,345.505920 
z"
      />
      <path
        fill={color}
        opacity="1.000000"
        stroke="none"
        d="
M125.287224,259.318207 
	C118.503647,272.827301 112.305229,286.224670 105.264389,299.163605 
	C95.877350,316.414093 90.446365,334.932678 85.977470,353.864838 
	C83.436844,364.628082 80.697220,375.346069 77.908836,386.048401 
	C76.453987,391.632355 72.680168,394.648224 66.980751,394.735199 
	C77.626648,342.268860 88.139053,290.017426 127.894218,250.160553 
	C128.398254,250.380524 128.902283,250.600479 129.406311,250.820450 
	C128.103317,253.547760 126.800316,256.275085 125.287224,259.318207 
z"
      />
      <path
        fill={color}
        opacity="1.000000"
        stroke="none"
        d="
M835.272827,439.634399 
	C830.974121,431.025787 826.730774,422.796478 822.862183,414.394653 
	C821.613770,411.683289 821.350525,408.518341 820.532898,405.131073 
	C834.716309,410.312775 866.207031,461.128967 865.789307,478.291229 
	C853.946106,466.245544 844.685181,453.116211 835.272827,439.634399 
z"
      />
      <path
        fill={color}
        opacity="1.000000"
        stroke="none"
        d="
M839.841980,376.168945 
	C839.377563,376.170898 839.040283,375.835785 838.703003,375.500641 
	C839.125061,375.611023 839.547058,375.721436 839.841980,376.168945 
z"
      />
    </svg>
  );
};
